__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "arbook";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@apollo/client", "3.12.4", () => (Promise.all([__webpack_require__.e(4212), __webpack_require__.e(9255), __webpack_require__.e(6907), __webpack_require__.e(318), __webpack_require__.e(7707), __webpack_require__.e(7243)]).then(() => (() => (__webpack_require__(5679))))));
			register("@flex-reality/i18n-sdk-react", "4.13", () => (Promise.all([__webpack_require__.e(9192), __webpack_require__.e(318), __webpack_require__.e(2424), __webpack_require__.e(2069)]).then(() => (() => (__webpack_require__(12069))))));
			register("@flexreality/ui-toolkit", "4.13", () => (Promise.all([__webpack_require__.e(318), __webpack_require__.e(3521)]).then(() => (() => (__webpack_require__(23521))))));
			register("graphql", "16.13.2", () => (__webpack_require__.e(3248).then(() => (() => (__webpack_require__(24845))))));
			register("i18next", "23.16.8", () => (__webpack_require__.e(4710).then(() => (() => (__webpack_require__(72635))))));
			register("mixpanel-browser", "2.77.0", () => (__webpack_require__.e(2942).then(() => (() => (__webpack_require__(76751))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(753), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-i18next", "15.7.4", () => (Promise.all([__webpack_require__.e(318), __webpack_require__.e(7255)]).then(() => (() => (__webpack_require__(77255))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(1363), __webpack_require__.e(4412), __webpack_require__.e(4315), __webpack_require__.e(318), __webpack_require__.e(8142)]).then(() => (() => (__webpack_require__(54625))))));
			register("react", "18.3.1", () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))));
			initExternal(35114);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};